import { render, staticRenderFns } from "./ChronicDiseaseView.vue?vue&type=template&id=6e1972d7&scoped=true"
import script from "./ChronicDiseaseView.vue?vue&type=script&lang=js"
export * from "./ChronicDiseaseView.vue?vue&type=script&lang=js"
import style0 from "./ChronicDiseaseView.vue?vue&type=style&index=0&id=6e1972d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1972d7",
  null
  
)

export default component.exports